module.exports = __webpack_public_path__ + "img/diagram-sankey.eb4c4e03.svg";